import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdCheck, MdContentCopy } from "react-icons/md";
import { NAME_SPACES } from "shared/locales/constants";
import phoneCallbackIcon from "../../../../Assets/icons/phone_callback.svg";
import Button from "../../../Button";
import { allowLeave } from "./useHelpPrompts";

const PHONE_NUMBER = "+33 9 78 45 41 15";
const CALL_LEAVE_GRACE = 1000;
const COPIED_RESET_DELAY = 2000;

function CallUs() {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("HELP_MODAL.CALL", { returnObjects: true });
  const [copied, setCopied] = useState(false);

  const copyNumber = async () => {
    try {
      await navigator.clipboard.writeText(PHONE_NUMBER.replace(/\s/g, ""));
      setCopied(true);
      setTimeout(() => setCopied(false), COPIED_RESET_DELAY);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="acoris-help-modal__call">
      <span className="acoris-help-modal__call-label">
        {TRANSLATION?.LABEL}
      </span>
      <div className="acoris-help-modal__call-row">
        <Button
          type="primary-outlined"
          className="acoris-help-modal__call-button"
          href={`tel:${PHONE_NUMBER.replace(/\s/g, "")}`}
          icon={<img src={phoneCallbackIcon} alt="" />}
          onClick={() => allowLeave(CALL_LEAVE_GRACE)}
        >
          {TRANSLATION?.BUTTON}
        </Button>
        <span className="acoris-help-modal__call-number">
          {PHONE_NUMBER}
          <button
            type="button"
            className="acoris-help-modal__call-copy"
            title={copied ? TRANSLATION?.COPIED : TRANSLATION?.COPY}
            aria-label={copied ? TRANSLATION?.COPIED : TRANSLATION?.COPY}
            onClick={copyNumber}
          >
            {copied ? <MdCheck size={18} /> : <MdContentCopy size={18} />}
          </button>
        </span>
      </div>
    </div>
  );
}

export default CallUs;
